// extracted by mini-css-extract-plugin
module.exports = {"wrap":"toast_wrap__3DM1h","shell":"toast_shell__2U516","content":"toast_content__LxRbZ"};